import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/from';
import 'rxjs/add/observable/forkJoin';

export class RoleDefinition {

  private testFunctions: Array<() => boolean | Observable<boolean> | Promise<boolean>> = [];

  constructor(
    private roleName: string,
    testFunction: () => boolean | Observable<boolean> | Promise<boolean>,
    private inheritedRoles: Array<string> = []
  ) {
    this.addTest(testFunction);
  }

  public getRoleName(): string {
    return this.roleName;
  }

  public addTest(testFunction: () => boolean | Observable<boolean> | Promise<boolean>) {
    this.testFunctions.push(testFunction);
  }

  public addInheritedRoles(roles: Array<string>) {
    for (let role of roles) {
      if (this.inheritedRoles.indexOf(role) !== -1) {
        this.inheritedRoles.push(role);
      }
    }
  }

  public getInheritedRoles(): Array<string> {
    return this.inheritedRoles;
  }

  public mergeTests(): Observable<boolean> {
    let testResults: any[] = this.testFunctions
      .map((test): Observable<boolean> | Promise<boolean> => {
        let testResult = test.call(this);

        if ('boolean' === typeof testResult) {
          return Observable.from([testResult]);
        }

        return testResult;
      });

    testResults.push((...testsResults: Array<boolean>): boolean =>
      testsResults.reduce((prev: boolean, current: boolean): boolean => prev && current)
    );

    return Observable.forkJoin.apply(this, testResults);
  }

}



// WEBPACK FOOTER //
// /dist/src/app/security/permission/role-definition.ts